"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WatchJS = require("melanke-watchjs");
var watch = WatchJS.watch;

var Metrics = void 0;

var Noun_Stripe = void 0;
var noun_user = void 0;
var raven = void 0;
var url_to_array = void 0;
var bind = function bind(fn, me) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return fn.apply(me, args);
    };
};

Metrics = require("../helpers/metrics").default;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

raven = require("../helpers/raven_client").default;

Noun_Stripe = function () {
    var Noun_Stripe = function () {
        function Noun_Stripe(key, data, plan, action, username) {
            _classCallCheck(this, Noun_Stripe);

            this.data = {};
            this.plan = {};
            this.errors = {};
            this.subscribe = bind(this.subscribe, this);
            this.a_la_carte_successful = void 0;
            this.data = data;
            this.plan = plan;
            this.action = action;
            this.username = username;
            this.set_publishable_key(key);
            this.validate();
        }

        _createClass(Noun_Stripe, [{
            key: "set_publishable_key",
            value: function set_publishable_key(key) {
                return Stripe.setPublishableKey(key);
            }
        }, {
            key: "check_for_errors",
            value: function check_for_errors(_ref) {
                var errors = _ref.errors;

                if (errors && errors.error && errors.error.code) {
                    this.errors[errors.error.code] = errors.error.message;
                    this.errored = true;
                }
            }
        }, {
            key: "validate",
            value: function validate() {
                if (!Stripe.card.validateCardNumber(this.data["card-number"])) {
                    this.errors.card_declined = "Your card was declined.";
                    this.errored = true;
                }
                if (!Stripe.card.validateExpiry(this.data["card-exp-month"], this.data["card-exp-year"])) {
                    this.errors.card_expiry = "Invalid expiration date";
                    this.errored = true;
                }
                if (!Stripe.card.validateCVC(this.data["card-cvc"])) {
                    this.errors.incorrect_cvc = "Your card’s security code is incorrect.";
                    this.errored = true;
                }
                return this.get_token(this.data);
            }
        }, {
            key: "get_token",
            value: function get_token() {
                return Stripe.card.createToken({
                    number: this.data["card-number"],
                    cvc: this.data["card-cvc"],
                    exp_month: this.data["card-exp-month"],
                    exp_year: this.data["card-exp-year"],
                    name: this.data["card-name"],
                    address_line1: this.data["address1"],
                    address_line2: this.data["address2"],
                    address_city: this.data["city"],
                    address_state: this.data["state"],
                    address_zip: this.data["postal_code"],
                    address_country: this.data["country"]
                }, this.subscribe);
            }
        }, {
            key: "update_card",
            value: function update_card(data) {
                var me = void 0;
                me = this;
                me.data = data;
                return _jquery2.default.ajax({
                    url: "//" + url_to_array[2] + "/" + me.username + "/card/update/",
                    type: "POST",
                    data: data,
                    success: function success(data, status, xhr) {

                        me.check_for_errors(data);
                        if (!data.errors) {
                            me.updated_data = data;
                            return me.updated = true;
                        } else {
                            return new Metrics().failed_cardsave(noun_user.id, data);
                        }
                    },
                    error: function error(xhr, status, _error) {

                        new Metrics().failed_cardsave(noun_user.id, _error);
                        return me.updated["false"];
                    }
                });
            }
        }, {
            key: "subscribe",
            value: function subscribe(status, response) {
                var me = void 0;
                me = this;
                if (status === 200) {
                    if (this.action === "a-la-carte") {
                        if (this.data.save_card === true) {
                            this.action = "update-a-la-carte";
                            this.update_card({
                                stripe_token: response.id
                            });
                        } else {
                            this.data = {
                                stripe_token: response.id
                            };
                            this.stripe_responce = response;
                            this.a_la_carte_successful = true;
                        }
                    } else {
                        this.update_card({
                            stripe_token: response.id,
                            receipt_info: this.data["receipt-info"],
                            plan: this.data["plan"],
                            seats: this.data["seats"],
                            coupon: this.data["coupon"],
                            referring_user: this.data["referring-user"],
                            next: this.data["next"]
                        });
                    }
                } else if (status === 402) {
                    if (!this.errored) {
                        this.errors.card_declined = "We could not process your payment. Please try again later.";
                        this.errored = true;
                        new Metrics().failed_upgrade(noun_user.id, response);
                    }
                } else {
                    this.errors.card_declined = "Something went wrong. Please contact <a href='mailto:info@thenounproject.com?subject=Failed upgrade (status " + status.toString() + ")' title='info@thenounproject.com'>info@thenounproject.com</a> for help";
                    this.errored = true;
                    new Metrics().failed_upgrade(noun_user.id, response);
                }
                return watch(this, "updated", function () {
                    var url = void 0;
                    if (me.updated === true) {

                        switch (this.action) {
                            case "update":
                                location.reload(true);
                                return;
                            case "update-a-la-carte":
                                this.stripe_responce = response;
                                this.a_la_carte_successful = true;
                                return;
                        }
                        this.check_for_errors(this.updated_data);

                        if (this.updated_data.card !== void 0) {
                            switch (this.plan) {
                                case "pro":
                                    url = "//" + url_to_array[2] + "/" + this.username + "/subscribe/pro/";
                                    break;
                                case "team":
                                    url = "//" + url_to_array[2] + "/" + this.username + "/subscribe/team/";
                            }

                            _jquery2.default.ajax({
                                url: url,
                                type: "POST",
                                data: me.data,
                                success: function success(data, status, xhr) {
                                    var icon = void 0;
                                    var redirect = void 0;
                                    var term = void 0;

                                    me.check_for_errors(data);
                                    if (!data.errors) {
                                        if (typeof data.next_url === "undefined") {
                                            me.errors.card_declined = "Something went wrong. Please contact <a href='mailto:info@thenounproject.com?subject=Failed upgrade (status " + status.toString() + ")' title='info@thenounproject.com'>info@thenounproject.com</a> for help";
                                            me.errored = true;
                                            return new Metrics().failed_upgrade(noun_user.id, data);
                                        } else {
                                            (0, _jquery2.default)("button[type='submit']").addClass("success").removeClass("processing");
                                            if (location.search.includes("term")) {
                                                term = location.search.split("=")[1].split("&")[0];
                                                icon = location.search.split("=")[2];
                                                redirect = "//" + url_to_array[2] + "/term/" + term + "/" + icon + "/";
                                            } else {
                                                redirect = "//" + url_to_array[2] + data.next_url;
                                            }
                                            if (data.is_new_subscription) {
                                                return new Metrics().upgrade(data, redirect);
                                            } else {
                                                return window.location.href = redirect;
                                            }
                                        }
                                    }
                                },
                                error: function error(xhr, status, _error2) {
                                    new Metrics().failed_upgrade(noun_user.id, _error2);

                                    return console.log(_error2);
                                }
                            });
                        } else {
                            me.errors.card_declined = "Something went wrong. Please contact <a href='mailto:info@thenounproject.com?subject=Failed upgrade (card error)' title='info@thenounproject.com'>info@thenounproject.com</a> for help";
                            me.errored = true;
                            new Metrics().failed_upgrade(noun_user.id, "Customer card is undefined");
                        }
                    }
                });
            }
        }, {
            key: "a_la_carte",
            value: function a_la_carte(term_slug, icon_id) {
                return watch(this, "a_la_carte_successful", function () {
                    var me = void 0;
                    me = this;
                    if (this.updated === true) {
                        delete this.data.stripe_token;
                    }
                    return _jquery2.default.ajax({
                        type: "POST",
                        data: this.data,
                        success: function success(data, status, xhr) {
                            var path = void 0;

                            me.check_for_errors(data);
                            if (!data.errors) {
                                path = "/icon/" + icon_id + "/file-options/";
                                return new Metrics().record_purchase(function () {
                                    return window.location.href = path;
                                });
                            }
                        },
                        error: function error(xhr, status, _error3) {

                            return me.parse_errors(me, stripe);
                        }
                    });
                });
            }
        }]);

        return Noun_Stripe;
    }();

    return Noun_Stripe;
}();

exports.default = Noun_Stripe;